import { KeyboardLayoutObject } from 'simple-keyboard/build/interfaces';

export enum KeyboardTemplate {
	Simple,
	Standard,
	StandardWithSpace,
	StandardWithSpaceAndEnter,
	Pin,
}

export function getKeyboardLayout(template: KeyboardTemplate): KeyboardLayoutObject {
	switch (template) {
		case KeyboardTemplate.Simple:
			return {
				default: ['1 2 3 4 5 6 7 8 9 0', 'q w e r t y u i o p', 'a s d f g h j k l', 'z x c v b n m {backspace}'],
			};
		case KeyboardTemplate.Pin:
			return {
				default: ['1 2 3', '4 5 6', '7 8 9', '0 {backspace}'],
			};
		case KeyboardTemplate.Standard:
			return {
				default: ['1 2 3 4 5 6 7 8 9 0 {backspace}', 'q w e r t y u i o p', 'a s d f g h j k l', '{shift} z x c v b n m'],
				shift: ['! @ # $ % ^ & _ + / ? {backspace}', 'Q W E R T Y U I O P', 'A S D F G H J K L', '{shift} Z X C V B N M'],
			};
		case KeyboardTemplate.StandardWithSpace:
			return {
				default: ['1 2 3 4 5 6 7 8 9 0 {backspace}', 'q w e r t y u i o p', 'a s d f g h j k l', '{shift} z x c v b n m', '{space}'],
				shift: ['! @ # $ % ^ & _ + / ? {backspace}', 'Q W E R T Y U I O P', 'A S D F G H J K L', '{shift} Z X C V B N M', '{space}'],
			};
		case KeyboardTemplate.StandardWithSpaceAndEnter:
			return {
				default: ['1 2 3 4 5 6 7 8 9 0 {backspace}', 'q w e r t y u i o p', 'a s d f g h j k l {ent}', '{shift} z x c v b n m', '{space}'],
				shift: ['! @ # $ % ^ & _ + / ? {backspace}', 'Q W E R T Y U I O P', 'A S D F G H J K L {ent}', '{shift} Z X C V B N M', '{space}'],
			};
	}
}
